import { instance4 } from "App/constants";
import moment from "moment";

const urlGet = "/wmsAsset/maintance/list-id-asset";

export const RESET_STATE_FORM_FILTER = {
  id: "",
  fixasset_id: "",
  vendor_id: "",
  nama_vendor:"Pilih Vendor",
  status: "",
  jumlah: 10,
  halaman: 1,
  tglAwal: "",
  tglAkhir: "",
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "kelengkapan",
    disablePadding: false,
    label: "KELENGKAPAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "no_faktur",
    disablePadding: false,
    label: "NO. FAKTUR",
    align: "center",
    minWidth: "180px",
  },
  {
    id: "deskripsi_kerusakan",
    disablePadding: false,
    label: "DESKRIPSI KERUSAKAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "is_garansi",
    disablePadding: false,
    label: "GARANSI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_akhir_garansi",
    disablePadding: false,
    label: "TGL AKHIR GARANSI",
    align: "left",
    minWidth: "180px",
  },
];

export const getMaintenance = async (formFilter, id, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      id: "",
      fixasset_id: id,
      vendor_id: formFilter.vendor_id,
      status: "",
      tglAwal: formFilter.tgl_aktif ? moment(formFilter.tglAwal).format("YYYY-MM-DD") : "",
      tglAkhir: formFilter.tgl_aktif ? moment(formFilter.tglAkhir).format("YYYY-MM-DD") : "",
      tgl_aktif: false,
      jumlah: limit,
      halaman: pages,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
